<style scoped>
.mask {
  background: rgba(0, 0, 0, 0.4);
  height: 100vh;
  width: 7.5rem;
  z-index: 100;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.payBox {
  background: #fff;
  border-radius: 0.2rem 0.2rem 0 0;
  width: 7.5rem;
  padding: 0.3rem;
  box-sizing: border-box;
}
.topBox {
  display: flex;
  justify-content: flex-end;
}
.topBox img {
  width: 0.24rem;
  height: 0.24rem;
}
.clickBox {
  padding: 0.2rem;
}
.amount {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  color: #000;
  font-size: 0.8rem;
  line-height: 0.8rem;
}

.amount span {
  font-size: 0.3rem;
  line-height: 0.45rem;
}
.infoTitle {
  font-size: 0.28rem;
  color: #666;
  padding-bottom: 0.26rem;
  border-bottom: 0.01rem solid #eee;
  margin-top: 0.9rem;
}
.layer {
  height: 1.1rem;
  display: flex;
  justify-content: space-between;
  font-size: 0.32rem;
  color: #333;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #eee;
  align-items: center;
}

.iconBox {
  display: flex;
  align-items: center;
}

.iconBox img {
  width: 0.42rem;
  height: 0.42rem;
}

.iconBox span {
  margin-left: 0.45rem;
}

.btn {
  margin-top: 1.4rem;
  height: 0.88rem;
  background: #408bfb;
  border-radius: 0.1rem;
  line-height: 0.88rem;
  text-align: center;
  font-size: 0.34rem;
  color: #fff;
}
.choose {
  width: 0.34rem;
  height: 0.34rem;
  background: url("~assets/selectIcon.png") no-repeat center/cover;
}

.choose.active {
  background: url("~assets/selectIcon2.png") no-repeat center/cover;
}
</style>

<template>
  <div class="mask" @click="close">
    <div class="payBox" @click.stop="">
      <div class="topBox">
        <div class="clickBox" @click="close">
          <img src="~assets/close.png" alt="" />
        </div>
      </div>
      <div class="amount"><span>￥</span>{{ price }}</div>
      <div class="infoTitle">选择支付方式</div>
      <div class="layer" @click="selectPayType(0)">
        <div class="iconBox">
          <img src="~assets/aplipay.png" alt="" />
          <span>支付宝</span>
        </div>
        <div class="choose" :class="{ active: payType === 0 }"></div>
      </div>
      <div class="layer" @click="selectPayType(1)">
        <div class="iconBox">
          <img src="~assets/wxpay.png" alt="" />
          <span>微信</span>
        </div>
        <div class="choose" :class="{ active: payType === 1 }"></div>
      </div>
      <div class="btn" @click="pay()">确认付款</div>
    </div>
  </div>
</template>

<script>
import { getSources } from "../api";
export default {
  props: ["text", "price","microId","bookId"],
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      payType: 0,
    };
  },
  methods: {
    selectPayType(n) {
      this.payType = n;
    },
    close(){
        this.$emit('close',false)
    },
    async pay() {
      let obj = {};
      obj.payType = this.payType;
      obj.bookId = this.bookId;
      obj.microId = this.microId;
      obj.userId = localStorage.getItem('userId');

      let data = await getSources("/bear-scale/api/bigPay/toReqPayBook", obj);
      console.log(data);

      if (data.status === 0) {
        //                    this.$router.push(`/selectSex?scaleId=${scaleId}`)
        if (this.payType === 0) {
          let form = data.payView;

          const div = document.createElement("div");
          div.innerHTML = form; //此处form就是后台返回接收到的数据
          document.body.appendChild(div);
          document.forms[0].submit();
        } else {
          if (data.tradeType === "MWEB") {
            location.href = data.mweb_url;
          } else if (data.tradeType === "JSAPI") {
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              {
                appId: data.appId, // 公众号名称，由商户传入
                timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
                nonceStr: data.nonceStr, // 随机串
                package: data.package,
                signType: data.signType, // 微信签名方式：
                paySign: data.paySign, // 微信签名
              },
              (res) => {
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                  //                                        this.$toast({message: '支付成功'})
                  // 支付成功之后跳转的路由
                    this.$router.push(`/my`);
                } else {
                  //                                        this.$toast({message: '支付失败'})
                  alert(`支付失败`);
                }
              }
            );
          } else if (data.tradeType === "NATIVE") {
            this.downloadData.url = data.code_url;
          }
        }
      } else {
        alert(data.msg);
      }
    },
    back() {
      var ua = navigator.userAgent;
      if (this.$route.query.type == 1) {
        var isIos = /iPhone/i.test(ua);
        var isAndroid = /Android/i.test(ua);
        isIos && window.webkit.messageHandlers.BackToNormal.postMessage(1);
        isAndroid && XinMaoEap.finshActivity();
      } else {
        history.back();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payAssembly.vue?4a3d5ba0